import { getAllParents } from "@cervval.js/client-html5-core/src/tools/dom.tools";
import { CjsDayAgendaColumnView } from "../dayAgendaColumnView/dayAgendaColumnView";
import { CjsDayAgenda } from "./dayAgenda";
import { } from "./dayAgenda.types";
import { COLUMN_HOVERED_CLASS, COLUMN_HOVERED_NOT_ALLOWED_CLASS } from "./dayAgendaUi.helper.consts";

/** Remove hover style when hover RowView */
export function removeColumnViewsHoverStyle<
    ItemObject,
    ColumnObject
>(hoverRowView: CjsDayAgendaColumnView<ItemObject, ColumnObject> | undefined, agenda: CjsDayAgenda<ItemObject, ColumnObject>): void {
    // Before remove hover style
    for (const colView of Object.values(agenda.columnViewsByUidCache)) {
        if (colView === hoverRowView) { continue; }
        if (!colView.classList.contains(COLUMN_HOVERED_CLASS)) { continue; }
        colView.classList.remove(COLUMN_HOVERED_CLASS, COLUMN_HOVERED_NOT_ALLOWED_CLASS);
    }
}

/** Install the hover interaction on the agenda and the smartTable */
export function installHoverInteraction<
    ItemObject,
    ColumnObject
>(agenda: CjsDayAgenda<ItemObject, ColumnObject>): void {

    // Hover on agenda
    agenda.components.columnsContainer.addEventListener("mouseover", (e) => {
        if (agenda.isDraggingItem) { return; }
        const currentHoveredColumnView = getAllParents(e.target as HTMLElement).find(elt => elt instanceof CjsDayAgendaColumnView) as CjsDayAgendaColumnView<ItemObject, ColumnObject> | undefined;
        removeColumnViewsHoverStyle(currentHoveredColumnView, agenda);

        if (!agenda.options.enableHover) { return; }  // No hover on sticky col.
        currentHoveredColumnView?.classList.add(COLUMN_HOVERED_CLASS);
    });

    // Mouseout agenda
    agenda.components.columnsContainer.addEventListener("mouseout", _ => removeColumnViewsHoverStyle(undefined, agenda));
}

